<script>
    import Panel from "../generics/Panel.svelte"
    import StarsRating from "./ratings/StarsRating.svelte";

    export let read = false;
</script>

<Panel inactive={read}>
    <StarsRating rating={4} />
    <p>
        Came here for a little brunch and was very pleased.
        Staff are friendly and knowledgeable, breakfast is served all day .
    </p>
</Panel>

<style lang="scss">
    @import "src/constants";

    p {
        margin: 0;
        font-family: $ff-sans;
        font-size: $fs-review;
    }
</style>
